import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPin02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.384 2.41a11.56 11.56 0 0 0-.706-.67c-.222-.185-.52-.395-.91-.474a2 2 0 0 0-1.494.287c-.333.219-.531.524-.669.779-.131.243-.263.552-.406.884l-1.085 2.53a5.528 5.528 0 0 1-.045.105v.002h-.002a6.03 6.03 0 0 1-.08.082l-1.56 1.56a6 6 0 0 1-.128.126l-.002.002h-.002c-.034.008-.08.018-.175.037L5.413 8.4c-.44.088-.835.167-1.145.26-.311.092-.712.243-1.016.585a2 2 0 0 0-.485 1.602c.063.453.313.802.52 1.051.207.249.492.534.81.851l2.865 2.866-4.95 4.95a1 1 0 1 0 1.415 1.414l4.95-4.95 2.866 2.867c.317.317.602.602.851.81.25.207.598.456 1.05.519a2 2 0 0 0 1.603-.485c.342-.303.494-.705.586-1.015.092-.31.171-.706.259-1.146l.741-3.707.037-.175v-.002l.002-.002.125-.127 1.561-1.561.081-.08.001-.001h.002c.02-.01.047-.022.104-.046l2.531-1.085c.332-.142.641-.275.884-.406.255-.137.56-.336.779-.669a2 2 0 0 0 .287-1.494c-.079-.39-.289-.688-.474-.91-.177-.212-.414-.45-.67-.706l-5.2-5.199Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgPin02.displayName = 'Pin02';
export default SvgPin02;
